import { openWorkspaceDb } from '@/offline/db'
import { atomicLocalWrite, buildOperation } from '@/offline/queue'
import { pushOutbox, type PushSummary } from '@/offline/sync'
import { supabaseTransport } from '@/offline/transport'
import type { BuiltDeviceUpdate } from './deviceUpdatePayload'

/** Apply an edit locally (same UUIDs, revision+1) with its outbox op, then sync. */
export async function saveDeviceUpdate(workspaceId: string, built: BuiltDeviceUpdate): Promise<PushSummary> {
  const db = openWorkspaceDb(workspaceId)
  const op = buildOperation({
    workspace_id: workspaceId,
    entity_id: built.device.id,
    entity_type: 'device',
    expected_revision: built.expectedRevision,
    action: 'device.update',
    payload: built.payload,
  })
  await atomicLocalWrite(
    db,
    [db.devices, db.device_imeis, db.purchases],
    async () => {
      await db.devices.put(built.device)
      await db.device_imeis.bulkPut(built.imeis)
      if (built.purchase) await db.purchases.put(built.purchase)
    },
    op,
  )
  return pushOutbox(db, supabaseTransport())
}
